export const GridSchema = (props) => {
  return {
    title: 'VideoPage Block',
    block: '__grid',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],

    properties: {},
    required: [],
  };
};
